import { STRINGS } from '@/constants/strings';
import { colors, guardianColors } from '@/theme/colors';

export const SESSION_DETAIL_STRINGS = STRINGS.guardian.playerSessionDetails;

export const LEVEL_BORDER_EDGE_WIDTH = 3;
export const LEVEL_BORDER_TIP_WIDTH = 0;
export const LEVEL_BORDER_STEPS = 24;

export const CHECKPOINT_STATUS_COLORS = {
  completed: colors.Success,
  incomplete: guardianColors['6'],
} as const;

export const BADGE_STATUS_COLORS = {
  earned: guardianColors['Main/Main'],
  working: guardianColors['Primary Color'],
  notStarted: guardianColors['6'],
} as const;
